import Service from "../Service";
import Vue from "vue";
const resource = "GenUbigee/";

export default {
 /* save(prd, requestID) {
    console.log(prd);
    return Service.post(resource + "save", prd, {
      params: { requestID: requestID },
    });
  },

  pagination(parameters, requestID) {
    console.log('parametro',parameters)
    return Service.post(resource + "pagination", parameters, {
      params: { requestID: requestID },
    });
  },*/

  //CODIGO EDGAR
  listUbigee(search, RequestID){
    
      return Service.post(resource + "listUbigee",{},{
      params:{Search: search, RequestID: RequestID}
    });
   
  },
 GetUrllistUbigee(){
    return Vue.prototype.$http.defaults.baseURL + "/GenUbigee/listUbigee";
  },
};
